import React from 'react';
import { Panel } from '../../../../../../common/component/Collapse';
import Input from '../../../../../../common/component/Input';
import TextArea from '../../../../../../common/component/TextArea';
import { Icon } from 'antd';
import { debounce } from 'lodash';

export default class ChecklistItem extends Panel {

    state = {
        title: this.props.title || '',
        content: this.props.content || '',
    };

    componentDidMount() {
        this.setState({ title: this.props.title, content: this.props.content });
    }

    // componentDidUpdate() {
    //     this.setState({ title: this.props.title, content: this.props.content });
    // }

    render() {
        const { t, collapseState, index } = this.props;
        const { title, content } = this.state;
        return (
            <Panel
                header={collapseState.includes(String(index)) ?
                    <Input placeholder={t(`item.tour.tourTitle`)} type={`text`}
                        className={`form-control`}
                        name={`checklistTitle${index}`} onClick={e => e.stopPropagation()} onChange={this.onChangeTitle}
                        value={title || ''} />
                    : (title || t(`item.tour.checkListEmptyTitle`))
                }
                key={String(index)}
                extra={<Icon type="delete" className="mr-2 btn-delete" onClick={(e) => this.props.onRemove(index, e)} />}
            >
                <TextArea placeholder={t(`item.tour.checklistContent`)}
                    className="form-control ml-4" name={`checklistContent${index}`} onChange={this.onChangeContent}
                    value={content} />
            </Panel>
        )
    }

    onChangeTitle = (e) => {
        const { index } = this.props;
        this.setState({ title: e.target.value })
        debounce(() => this.props.onChangeTitle(index, e.target.value), 600).call()
    }

    onChangeContent = (e) => {
        const { index } = this.props;
        this.setState({ title: e.target.value })
        debounce(() => this.props.onChangeContent(index, e.target.value), 600).call()
    }
}

ChecklistItem.defaultProps = {
    onRemove: (index, event) => { },
    onChangeTitle: (index, value) => { },
    onChangeContent: (index, value) => { },
};